import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ResponseDto } from 'src/app/modules/shared/dtos/response.dto';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class UpdatePasswordService {
    private readonly RESET_GET_ENDPOINT = environment.baseUrl + 'Configuration/partner/';
    public constructor(private http: HttpClient) { }

    public resetPassword(newPassword: string, partnerId: string, isReset: boolean) : Observable<ResponseDto> {
        const url = this.RESET_GET_ENDPOINT + partnerId + '/password/' + isReset;
        return this.http.put<ResponseDto>(url, {}, { headers: { newpassword: btoa(newPassword) } });
    }
}
